import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CancelIcon from '@mui/icons-material/Cancel';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import grey from "@material-ui/core/colors/grey";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Avatar from "@material-ui/core/Avatar";
import { BreadcrumbPage } from "../../shared";
import Help from "@material-ui/icons/Help";
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import { Shedulerfilter } from "./SchedulerObject";
import PrintIcon from '@material-ui/icons/Print';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Moment from "react-moment";
import ShedularDetails from './ShedularDetails';
import Button from "@material-ui/core/Button";
import DeleteIcon from '@mui/icons-material/Delete';
import pdficon from '../Helpsection_images/pdficon.jpg';
import downloadpdf from '../Helpsection_images/downloadpdf.jpg';
import Close from '../Helpsection_images/Close.jpg';
import Preview from '../Helpsection_images/Preview.jpg';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { customerList, equipmentList } from "./SchedulerObject"
import {
  KeyboardDatePicker,
  DatePicker
} from "@material-ui/pickers";
import Checkbox from '@mui/material/Checkbox';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getRequest, postRequest } from "../../services/ApiServices";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import ClearIcon from '@mui/icons-material/Clear';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear1 from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import reset from '../Helpsection_images/reset.jpg';
import {
  MuiThemeProvider,
  createMuiTheme,
  Tooltip,
} from "@material-ui/core";
import {
  FormHelperText,
  Input,
  Radio,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import FilterComponents from "../FilterComponents/FilterComponents";
import { getCookie } from "../../services/Cookies";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ClearAllTwoToneIcon from '@mui/icons-material/ClearAllTwoTone';
import { useMouseHovered } from "react-use";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import TextField from '@mui/material/TextField';
import { withRouter } from 'react-router-dom';
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),

    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",

    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    },
    "& .tss-ynxllk-MUIDataTableFilter-root": {
      minwidth: "120px"
    }
  },
  stepperIcon: {
    "& .Mui-completed .MuiStepIcon-root ": { color: "#000000" },
    "& .Mui-active .MuiStepIcon-root": { color: "#ff4717" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#bdbdbd" }
  },
  txtInput: {
    "& input": {
      padding: "1px 0px 4px 10px",
    },
    "& fieldset": {
      borderRadius: 0,
    },
  },
  txtInput1: {
    "& input": {
      padding: "1px 0px 4px 10px",
      width: "820px",
    },
    "& fieldset": {
      borderRadius: 0,
    },
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderRadius: 8,
  },
  fgreen:
  {
    color: "green"
  },
  fred:
  {
    color: "red"
  },
  TableTheme: {
    fontSize: "20px",
    boxShadow: "0 0 0 #eee",
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  active: {
    backgroundColor: "#F5F5F4",
  },
  table: {
    minWidth: 650,
  },
  root: {
    display: "flex",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: "0 30px",
    minHeight: "86vh",
    marginTop: "0 !important",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  radioInput: {
    padding: 0,
    "&.Mui-checked": {
      color: "#ff4717",
    },
  },

  btnStyle3: {
    color: "#ff4717",
    boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
    marginLeft: "15px",
    padding: "8px 8px",
    marginLeft: "18px",
    cursor: "pointer",
  },


  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
}));

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Scheduler(props) {
  const history = useHistory();
  const classes = useStyles();
  const [schedulerList, setSchedulerList] = useState([]);
  const [selectedSchedulerListShip, setSelectedSchedulerListShip] = useState([]);
  const dispatch = useDispatch();
  const BreadcrumbList = [
    { name: "Sampling schedule recommended by VPS-Ship", url: "" },
  ];
  const [open, setOpen] = React.useState(false);
  const [openStepper, setOpenStepper] = React.useState(false);
  const [openPreview, setOpenPreview] = React.useState(false);
  const [openPrint, setOpenPrint] = React.useState(false);
  const [openRemoveLabel, setOpenRemoveLabel] = React.useState(false);
  const [chechboxVal, setCheckboxVal] = React.useState(null);
  const [dropDownOpen, setdropDownOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [flagVal, setFlagVal] = React.useState("");
  const [pdfName, setpdfName] = React.useState("");
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());
  const [applyFilterValue, setApplyFilterValue] = useState({});
  const [formObj, setFormObj] = useState(Shedulerfilter);
  const [Notivalue, setNotivalue] = useState("");
  const [NotificationDisplay, setNotificationDisplay] = useState("");
  const [editScheduleCheck, setEditScheduleCheck] = useState("");
  const [scheduleValue, setScheduleValue] = React.useState("");
  const [filterChipValue, setFilterChipValue] = React.useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepsVal, setStepsVal] = React.useState("");
  const [stepperVal, setStepperVal] = React.useState([{ label: "" }]);
  const [pdfURL, setPdfURL] = useState("");
  const [openpdf, setOpenpdf] = React.useState(false);
  const [grouping, setGrouping] = React.useState(true);
  const checkboxSelectedValue = [];
  const steps = stepperVal;
  let stepperparameters = {
    created_date: moment(getCurrentDate()).format('DD/MM/YYYY'),
    vesselID: "",
    EquipmentID: "",
    Sampledate: "",
    CustomerName: "",
    VPS_EquipmentID_No: "",
    ManufacturerMake: "",
    Model: "",
    PrimaryComponent: "",
    sampled_by: "",
    Comments: "",
    Oil_brand: "",
    Oil_Grade: "",
    Oil_Quantity_in_system: "",
    Fuel_in_user: "",
    Daily_top_up_in_liters: "",
    Unit_Service_time: "",
    Oil_Service_time: "",
    vesselKey: "",
    MachineryKey: "",
  }
  let editColor = {
    oilBrand: false,
    oilGrade: false,
    oilQuantityInSystem: false,
    dailyTopUpInLiters: false,
    fuelInUse: false,
    unitServiceTime: false,
    oilServiceTime: false,
    sampledBy: false,
    comments: false,
  }
  const [editValueColor, setEditValueColor] = useState(editColor)
  const [editScheduleValues, setEditScheduleValues] = useState(stepperparameters);
  const [stepperFormvalues, setStepperFormvalues] = useState(stepperparameters);
  const [previewValues, setpreviewValues] = useState([]);
  const [previewColors, setPreviewColors] = useState([]);
  const [openform, setOpenform] = React.useState(false);
  const handleClickOpenForm = () => {
    setOpenform(true);
  };
  const handleClickClose = () => {
    setOpenform(false);
  };
  useEffect(() => {
    debugger
    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getShedularTotalData(Obj);

    } else {
      getShedularTotalData();
    }
  }, [])

  const NotificationClear = (props) => {
    setFlagVal("");
    history.push("/dashboard/scheduler");
    let JSONFormat={};
    if (getCookie('historicvessels') === 'true') {
      JSONFormat.HistoricVessel = true;
    } else {
      JSONFormat.HistoricVessel = false;
    }
    getShedularTotalData(JSONFormat);
  }

  const SchedulerGrouping = () => {
    getShedularTotalData(applyFilterValue);
    if (grouping) {
      setGrouping(false);
    } else {
      setGrouping(true);
    }
  }

  const toolTipValue = () => {
    if (grouping) {
      return "Ungrouping"
    } else {
      return "Grouping"
    }
  }


  const onClear = () => {
    debugger
    setFlagVal("");
    setStepsVal("");
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getShedularTotalData(Obj);

    } else {
      getShedularTotalData();
    }
  }

  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      },
    },
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: "500px",
          }
        }
      }
    },

    MUIDataTableToolbar: {
      actions: {
        display: "flex",
        flex: "initial",
        "& > span, & > button": {
          order: 99
        },
        "& > span:last-child, & > button:last-child": {
          order: 1
        },
        // target any icon
        "& > span:nth-child(4), & > button:nth-child(4)": {
          order: 2
        }
      }
    }

  })

  const handleRaiseRequest = (scrollType) => () => {
    setSelectedRows(checkboxSelectedValue)
    setOpen(true);
    setScroll(scrollType);
  };

  const handleCloseRaiserequest = () => {
    setOpen(false);
  };

  const handleFilterListOpen = (event) => {
    setCheckboxVal(event.currentTarget);
    setdropDownOpen(true);
  };

  const handleFilterListClose = () => {
    setdropDownOpen(false);
  }

  const handleFilterListApply = (event) => {
    let filterValue = event.currentTarget.outerText;
    setCheckboxVal(null);
    setdropDownOpen(false);
    setFlagVal(event.currentTarget.outerText);
    let listOfSchedulerShip = [];
    let existCurrentVesselName = [];
    let existContractId = [];
    let filterScheduleVal = [];
    let listofStepperValue = [];
    if (grouping) {
      if (filterValue !== "" && filterValue !== "All") {
        filterChipValue.map((row) => {
          if (row.flag === filterValue) {
            listofStepperValue.push(row);
          }
        })
        editScheduleCheck.map((row) => {
          if (row.flag === filterValue) {
            let currentVesselindex = existCurrentVesselName.indexOf(row.currentVesselName);
            let contractIdIndex = existContractId.indexOf(row.axContractId);
            if (currentVesselindex > -1) {
              let subObj = {
                ...equipmentList,
                Equipment: row.equimentName,
                EquipmentIdNo: row.vps_equipment_id_no,
                Make: row.make,
                Model: row.model,
                LoBrand: row.lastKnownLubeBrand,
                LoGrade: row.lastKnownLubeGrade,
                Flag: row.flag,
                LastSampleDate: row.lastSamplingDate,
                SamplingFrequency: row.samplingFrequency,
                NextSampleDate: row.nextSamplingDate,
                ScheduleId: row.schedulerMasterVessel_ID,
              }
              listOfSchedulerShip[currentVesselindex].EquipmentList.push(subObj);

            } else {
              existCurrentVesselName.push(row.currentVesselName);
              existContractId.push(row.axContractId);
              let subObj = {
                ...equipmentList,
                Equipment: row.equimentName,
                EquipmentIdNo: row.vps_equipment_id_no,
                Make: row.make,
                Model: row.model,
                LoBrand: row.lastKnownLubeBrand,
                LoGrade: row.lastKnownLubeGrade,
                Flag: row.flag,
                LastSampleDate: row.lastSamplingDate,
                SamplingFrequency: row.samplingFrequency,
                NextSampleDate: row.nextSamplingDate,
                ScheduleId: row.schedulerMasterVessel_ID,
              }
              var ast = row.currentVesselName ? row.currentVesselName : "";
              var assetWithSpace = "";
              if (ast) {
                assetWithSpace = ast.split("(")[0] + " (" + ast.split("(")[1];
              }
              let obj = {
                ...customerList,
                Asset: assetWithSpace,
                CustomerContract: row.customerName,
                contractNumber: row.axContractId,
                Flag: row.flag,
                GroupFlag: row.groupFlag,
                EquipmentList: [subObj]
              }
              listOfSchedulerShip.push(obj);
            }
          }
        })
      }
      else {
        filterChipValue.map((row) => {
          //if (row.flag !== "Good" && row.flag !== "Scheduled") {
          if (row.flag !== "Scheduled") {
            listofStepperValue.push(row);
          }
        })
        editScheduleCheck.map((row) => {
          let currentVesselindex = existCurrentVesselName.indexOf(row.currentVesselName);
          let contractIdIndex = existContractId.indexOf(row.axContractId);
          if (currentVesselindex > -1) {
            let subObj = {
              ...equipmentList,
              Equipment: row.equimentName,
              EquipmentIdNo: row.vps_equipment_id_no,
              Make: row.make,
              Model: row.model,
              LoBrand: row.lastKnownLubeBrand,
              LoGrade: row.lastKnownLubeGrade,
              Flag: row.flag,
              LastSampleDate: row.lastSamplingDate,
              SamplingFrequency: row.samplingFrequency,
              NextSampleDate: row.nextSamplingDate,
              ScheduleId: row.schedulerMasterVessel_ID,
            }
            listOfSchedulerShip[currentVesselindex].EquipmentList.push(subObj);

          } else {
            existCurrentVesselName.push(row.currentVesselName);
            existContractId.push(row.axContractId);
            let subObj = {
              ...equipmentList,
              Equipment: row.equimentName,
              EquipmentIdNo: row.vps_equipment_id_no,
              Make: row.make,
              Model: row.model,
              LoBrand: row.lastKnownLubeBrand,
              LoGrade: row.lastKnownLubeGrade,
              Flag: row.flag,
              LastSampleDate: row.lastSamplingDate,
              SamplingFrequency: row.samplingFrequency,
              NextSampleDate: row.nextSamplingDate,
              ScheduleId: row.schedulerMasterVessel_ID,
            }
            var ast = row.currentVesselName ? row.currentVesselName : "";
            var assetWithSpace = "";
            if (ast) {
              assetWithSpace = ast.split("(")[0] + " (" + ast.split("(")[1];
            }
            let obj = {
              ...customerList,
              Asset: assetWithSpace,
              CustomerContract: row.customerName,
              contractNumber: row.axContractId,
              Flag: row.flag,
              GroupFlag: row.groupFlag,
              EquipmentList: [subObj]
            }
            listOfSchedulerShip.push(obj);
          }

        })
      }
    }
    else {
      if (filterValue !== "" && filterValue !== "All") {
        filterChipValue.map((row) => {
          if (row.flag === filterValue) {
            listofStepperValue.push(row);
          }
        });
        editScheduleCheck.map((row) => {
          if (row.flag === filterValue) {
            listOfSchedulerShip.push(row);
          }
        });
      }
      else {
        filterChipValue.map((row) => {
          //if (row.flag !== "Good" && row.flag !== "Scheduled") {
          if (row.flag !== "Scheduled") {
            listofStepperValue.push(row);
          }
        });
        listOfSchedulerShip = editScheduleCheck;
      }
    }
    setScheduleValue(listofStepperValue);
    setSchedulerList(listOfSchedulerShip);
  };

  const handleStepperStepsDelete = () => {
    setOpenRemoveLabel(true);
  }

  const handleStepperEscape = () => {
    setOpenStepper(false);
    setpreviewValues([]);
    setPreviewColors([]);
    setStepsVal("");
    setActiveStep(0);
    setEditValueColor(editColor);
    setStepperFormvalues(stepperparameters);
    setEditScheduleValues(stepperparameters);
  }

  const handleStepperStepsDeleteClose = () => {
    setOpenRemoveLabel(false);
  }

  const handleRemoveStepperLabel = () => {
    if (editScheduleValues.length) {
      editScheduleValues.splice(activeStep, 1);
    }
    previewValues.splice(activeStep, 1);
    previewColors.splice(activeStep, 1);
    steps.splice(activeStep, 1);
    stepsVal.splice(activeStep, 1);
    if (activeStep === 0) {
      if (previewValues.length > 0) {
        setEditValueColor(previewColors[activeStep]);
        setStepperFormvalues(previewValues[activeStep]);
      }
      else {
        setActiveStep(0);
        setEditValueColor(editColor);
        if(editScheduleValues[0]){
          setStepperFormvalues({
            ...stepperFormvalues,
            Oil_brand: editScheduleValues[0].oil_brand,
            Oil_Grade: editScheduleValues[0].oil_Grade,
            Oil_Quantity_in_system: editScheduleValues[0].oil_Quantity_in_system,
            Fuel_in_user: editScheduleValues[0].fuel_in_user,
            Daily_top_up_in_liters: editScheduleValues[0].daily_top_up_in_liters,
            Unit_Service_time: editScheduleValues[0].unit_Service_time,
            Oil_Service_time: editScheduleValues[0].oil_Service_time,
            sampled_by: editScheduleValues[0].sampled_by,
            Comments: editScheduleValues[0].comments,
            vesselID: editScheduleValues[0].vesselID,
            EquipmentID: editScheduleValues[0].equipmentID,
            Sampledate: editScheduleValues[0].sampledate,
            CustomerName: editScheduleValues[0].customerName,
            VPS_EquipmentID_No: editScheduleValues[0].vpS_EquipmentID_No,
            ManufacturerMake: editScheduleValues[0].manufacturerMake,
            Model: editScheduleValues[0].model,
            PrimaryComponent: editScheduleValues[0].primaryComponent,
            vesselKey: editScheduleValues[0].vesselKey,
            MachineryKey: editScheduleValues[0].machineryKey,
          });
        }
        else{
          setStepperFormvalues({
            ...stepperFormvalues,
            Oil_brand: stepsVal[0].lastKnownLubeBrand,
            Oil_Grade: stepsVal[0].lastKnownLubeGrade,
            vesselID: stepsVal[0].currentVesselName,
            EquipmentID: stepsVal[0].equimentName,
            Sampledate: stepsVal[0].lastSamplingDate,
            CustomerName: stepsVal[0].customerName,
            VPS_EquipmentID_No: stepsVal[0].vps_equipment_id_no,
            ManufacturerMake: stepsVal[0].make,
            Model: stepsVal[0].model,
            PrimaryComponent: stepsVal[0].primaryComponent,
            vesselKey: stepsVal[0].vesselKey,
            MachineryKey: stepsVal[0].machineryKey,
            Oil_Quantity_in_system: "",
            Fuel_in_user: "",
            Daily_top_up_in_liters: "",
            Unit_Service_time: "",
            Oil_Service_time: "",
            sampled_by: "",
            Comments: "",
          })
        }   
      }
    }
    else {
      setEditValueColor(previewColors[activeStep - 1]);
      setStepperFormvalues(previewValues[activeStep - 1]);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    setOpenRemoveLabel(false);
    ToastSuccess("Removed Successfully");
  }


  const handleClose = () => {
    setOpenpdf(false)
    setpdfName("");
  };

  const handlePrintLabel = () => {
    previewValues.forEach((d, index) => {
      if (d.vesselID !== null) {
        if (index == 0) {
          let pdf = previewValues[0].vesselID.split(".").join(" ");
          setpdfName(pdf)
        }
        let isExist = d.vesselID;
        isExist = isExist.replace(")", " ");
        isExist = isExist.split("(");
        let vesselName = isExist[0];
        let imoNo = isExist[1];
        previewValues[index].vesselName = vesselName;
        previewValues[index].imoNo = imoNo;
      } else {
        if (index == 0) {
          let pdf = "label";
          setpdfName(pdf)
        }
        previewValues[index].vesselName = "";
        previewValues[index].imoNo = "";
      }
    })
    setOpenPrint(false);
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/PdfGeneration`;
    postRequest(url, previewValues, true)
      .then((response) => {
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "application/pdf" });

          const fileURL = URL.createObjectURL(file);

          setPdfURL(fileURL);
          setOpenpdf(true);
          setpreviewValues([]);
          setPreviewColors([]);
        } else {
          //ToastSuccess("Updated Unsucessfull");
        }
      })
      .catch((error) => {
      });
  }

  const handleEditStepperForm = () => {
    setOpenStepper(true);
    setOpenPreview(false);
    setStepperFormvalues(previewValues[activeStep]);
    setEditValueColor(previewColors[activeStep]);
  }

  const handleEditSchedule = () => {
    let isExists;
    let isGoodFlag = [];
    let isPresent = [];
    let data = [];
    let vesselid = [];

    (grouping ?
      checkboxSelectedValue.forEach((d) => {
        isExists = editScheduleCheck.find(o => o.equimentName == d.Equipment && o.flag == d.Flag && o.lastSamplingDate == d.LastSampleDate
          && o.lastKnownLubeBrand == d.LoBrand && o.lastKnownLubeGrade == d.LoGrade && o.make == d.Make
          && o.model == d.Model && o.nextSamplingDate == d.NextSampleDate && o.samplingFrequency == d.SamplingFrequency && o.schedulerMasterVessel_ID == d.ScheduleId);
        isPresent.push(isExists);
      })
      :
      isPresent = checkboxSelectedValue)

    isPresent.forEach((value, index) => {
      vesselid.push(value.schedulerMasterVessel_ID)
      if (value.schedulerMasterVessel_ID) {
        data.push(value.schedulerMasterVessel_ID);
      }
      // else if (value.flag === "Good") {
      //   isGoodFlag.push(value);
      // }
    })

    //if (data.length && !isGoodFlag.length) {
    if (data.length) {
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/GetSchedulerData`;

      postRequest(url, data)
        .then((res) => {
          if (res.status == 200) {
            let schedulerData = [];
            vesselid.forEach((value, index) => {
              if (value) {
                res.data.map((row) => {
                  if (row.id === value) {
                    schedulerData.push(row);
                  }
                })
              } else {
                schedulerData.push(null);
              }
            })

            if (schedulerData[0]) {
              setStepperFormvalues({
                ...stepperFormvalues,
                Oil_brand: schedulerData[0].oil_brand,
                Oil_Grade: schedulerData[0].oil_Grade,
                Oil_Quantity_in_system: schedulerData[0].oil_Quantity_in_system,
                Fuel_in_user: schedulerData[0].fuel_in_user,
                Daily_top_up_in_liters: schedulerData[0].daily_top_up_in_liters,
                Unit_Service_time: schedulerData[0].unit_Service_time,
                Oil_Service_time: schedulerData[0].oil_Service_time,
                sampled_by: schedulerData[0].sampled_by,
                Comments: schedulerData[0].comments,
                vesselID: schedulerData[0].vesselID,
                EquipmentID: schedulerData[0].equipmentID,
                Sampledate: schedulerData[0].sampledate,
                CustomerName: schedulerData[0].customerName,
                VPS_EquipmentID_No: schedulerData[0].vpS_EquipmentID_No,
                ManufacturerMake: schedulerData[0].manufacturerMake,
                Model: schedulerData[0].model,
                PrimaryComponent: schedulerData[0].primaryComponent,
                vesselKey: schedulerData[0].vesselKey,
                MachineryKey: schedulerData[0].machineryKey,
              });
            } else {
              setStepperFormvalues({
                ...stepperFormvalues,
                Oil_brand: isPresent[0].lastKnownLubeBrand,
                Oil_Grade: isPresent[0].lastKnownLubeGrade,
                vesselID: isPresent[0].currentVesselName,
                EquipmentID: isPresent[0].equimentName,
                Sampledate: isPresent[0].lastSamplingDate,
                CustomerName: isPresent[0].customerName,
                VPS_EquipmentID_No: isPresent[0].vps_equipment_id_no,
                ManufacturerMake: isPresent[0].make,
                Model: isPresent[0].model,
                PrimaryComponent: isPresent[0].primaryComponent,
                vesselKey: isPresent[0].vesselKey,
                MachineryKey: isPresent[0].machineryKey,
              });
            }
            setOpenStepper(true);
            setEditScheduleValues(schedulerData);
          } else {
            ToastError(res.data.message);
          }
        })
        .catch((error) => {
          //console.log(error);
          // ToastError(error.response.data.message);
        });
    }
    // else if (isGoodFlag.length) {
    //   ToastError("One of the selected flag is in Good")
    // }
    else {
      ToastError("Please Select the Scheduled flag")
    }


    setStepsVal(isPresent);
    const labelValue = isPresent.reduce((d, val) => {
      d.push({ label: val.currentVesselName });
      return d;
    }, []);
    setStepperVal(labelValue);
  }

  const handleScheduleOnClick = () => {
    let isExists;
    let isPresent = [];
    (grouping ?
      checkboxSelectedValue.forEach((d) => {
        isExists = editScheduleCheck.find(o => o.equimentName == d.Equipment && o.flag == d.Flag && o.lastSamplingDate == d.LastSampleDate
          && o.lastKnownLubeBrand == d.LoBrand && o.lastKnownLubeGrade == d.LoGrade && o.make == d.Make
          && o.model == d.Model && o.nextSamplingDate == d.NextSampleDate && o.samplingFrequency == d.SamplingFrequency && o.schedulerMasterVessel_ID == d.ScheduleId);
        isPresent.push(isExists);
      })
      :
      isPresent = checkboxSelectedValue)
    isPresent.forEach((value, index) => {
      if (value.schedulerMasterVessel_ID) {
        let data = [];
        data.push(value.schedulerMasterVessel_ID);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/GetSchedulerData`;

        postRequest(url, data)
          .then((res) => {
            if (res.status == 200) {
              let schedulerData = [];
              schedulerData = res.data;
              setStepperFormvalues({
                ...stepperFormvalues,
                Oil_brand: schedulerData[0].oil_brand,
                Oil_Grade: schedulerData[0].oil_Grade,
                Oil_Quantity_in_system: schedulerData[0].oil_Quantity_in_system,
                Fuel_in_user: schedulerData[0].fuel_in_user,
                Daily_top_up_in_liters: schedulerData[0].daily_top_up_in_liters,
                Unit_Service_time: schedulerData[0].unit_Service_time,
                Oil_Service_time: schedulerData[0].oil_Service_time,
                sampled_by: schedulerData[0].sampled_by,
                Comments: schedulerData[0].comments,
                vesselID: schedulerData[0].vesselID,
                EquipmentID: schedulerData[0].equipmentID,
                Sampledate: schedulerData[0].sampledate,
                CustomerName: schedulerData[0].customerName,
                VPS_EquipmentID_No: schedulerData[0].vpS_EquipmentID_No,
                ManufacturerMake: schedulerData[0].manufacturerMake,
                Model: schedulerData[0].model,
                PrimaryComponent: schedulerData[0].primaryComponent,
                vesselKey: schedulerData[0].vesselKey,
                MachineryKey: schedulerData[0].machineryKey,
              });
              setOpenStepper(true);
            } else {
              ToastError(res.data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
            // ToastError(error.response.data.message);
          });

      }
    })
    setStepsVal(isPresent);
    const labelValue = isPresent.reduce((d, val) => {
      d.push({ label: val.currentVesselName });
      return d;
    }, []);
    setStepperVal(labelValue);
  }

  const handlePrintlabelOnClick = () => {
    let isExists;
    let isPresent = [];
    (grouping ?
      checkboxSelectedValue.forEach((d) => {
        isExists = editScheduleCheck.find(o => o.equimentName == d.Equipment && o.flag == d.Flag && o.lastSamplingDate == d.LastSampleDate
          && o.lastKnownLubeBrand == d.LoBrand && o.lastKnownLubeGrade == d.LoGrade && o.make == d.Make
          && o.model == d.Model && o.nextSamplingDate == d.NextSampleDate && o.samplingFrequency == d.SamplingFrequency && o.schedulerMasterVessel_ID == d.ScheduleId);
        isPresent.push(isExists);
      }) :
      isPresent = checkboxSelectedValue)
    isPresent.forEach((value, index) => {
      if (value.schedulerMasterVessel_ID) {
        let data = [];
        data.push(value.schedulerMasterVessel_ID);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/GetSchedulerData`;

        postRequest(url, data)
          .then((res) => {
            if (res.status == 200) {
              let schedulerData = [];
              schedulerData = res.data;
              let printValues = [{}];
              let isSplit
              if (schedulerData[0].vesselID !== null) {
                let pdf = schedulerData[0].vesselID.split(".").join(" ");
                setpdfName(pdf);
                isSplit = schedulerData[0].vesselID;
                isSplit = isSplit.replace(")", " ");
                isSplit = isSplit.split("(");
              } else {
                let pdf = "";
                setpdfName(pdf);
                isSplit = ["", ""]
              }

              // let printValues = [{}];
              // let isSplit = schedulerData[0].vesselID;
              // isSplit = isSplit.replace(")", " ");
              // isSplit = isSplit.split("(");

              printValues[0].Oil_brand = schedulerData[0].oil_brand;
              printValues[0].Oil_Grade = schedulerData[0].oil_Grade;
              printValues[0].Oil_Quantity_in_system = schedulerData[0].oil_Quantity_in_system;
              printValues[0].Fuel_in_user = schedulerData[0].fuel_in_user;
              printValues[0].Daily_top_up_in_liters = schedulerData[0].daily_top_up_in_liters;
              printValues[0].Unit_Service_time = schedulerData[0].unit_Service_time;
              printValues[0].Oil_Service_time = schedulerData[0].oil_Service_time;
              printValues[0].sampled_by = schedulerData[0].sampled_by;
              printValues[0].Comments = schedulerData[0].comments;
              printValues[0].vesselID = schedulerData[0].vesselID;
              printValues[0].EquipmentID = schedulerData[0].equipmentID;
              printValues[0].Sampledate = schedulerData[0].sampledate;
              printValues[0].CustomerName = schedulerData[0].customerName;
              printValues[0].VPS_EquipmentID_No = schedulerData[0].vpS_EquipmentID_No;
              printValues[0].ManufacturerMake = schedulerData[0].manufacturerMake;
              printValues[0].Model = schedulerData[0].model;
              printValues[0].PrimaryComponent = schedulerData[0].primaryComponent;
              printValues[0].vesselKey = schedulerData[0].vesselKey;
              printValues[0].MachineryKey = schedulerData[0].machineryKey;
              printValues[0].created_date = schedulerData[0].created_date;
              printValues[0].vesselName = isSplit[0];
              printValues[0].imoNo = isSplit[1];
              printValues[0].schedulerMasterVessel_ID = isPresent[0].schedulerMasterVessel_ID;

              const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/PdfGeneration`;
              postRequest(url, printValues, true)
                .then((response) => {
                  if (response.status == 200) {
                    dispatch({ type: LOADING, payload: false });
                    const file = new Blob([response.data], { type: "application/pdf" });

                    const fileURL = URL.createObjectURL(file);

                    setPdfURL(fileURL);
                    setOpenpdf(true);
                  } else {
                    //ToastSuccess("Updated Unsucessfull");
                  }
                })
                .catch((error) => {
                });

            } else {
              ToastError(res.data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
            // ToastError(error.response.data.message);
          });

      }
    })
  }

  const handleStepperOpen = () => {
    if (selectedRows.length > 0) {
      if (selectedRows.length <= 20) {
        let isExist;
        //isExist = selectedRows.find(o => o.Flag === "Scheduled" || o.Flag === "Good" || o.flag === "Scheduled" || o.flag === "Good");
        isExist = selectedRows.find(o => o.Flag === "Scheduled" || o.flag === "Scheduled");
        if (isExist) {
          if (isExist.Flag === "Scheduled" || isExist.flag === "Scheduled") {
            ToastError("One of the selected flags are in Scheduled");
            setOpen(false);
          }
          // else {
          //   ToastError("One of the selected flags are in Good");
          //   setOpen(false);
          // }
        }
        else {
          getStepsLabelSelectedrows();
          setOpenStepper(true);
          setOpen(false);
        }
      }
      else {
        ToastError("Selected rows Exceeds the Limit");
        setOpen(false);
      }
    }
    else {
      if (scheduleValue.length) {
        // if (flagVal === "Good") {
        //     ToastError("The selected flags are already in Good");
        //     setOpen(false);
        // }
        // else 
        if (flagVal === "Scheduled") {
          ToastError("The selected flags are already in Scheduled");
          setOpen(false);
        }
        else if (flagVal !== "") {
          getStepsLabel();
          setOpenStepper(true);
          setOpen(false);
        }
        else {
          ToastError("Please select the Flag");
          setOpen(false);
        }
      }
      else {
        setOpen(false);
        ToastError("Sorry, No matching records found")
      }
    }
  }

  const handleSubmitStepperForm = () => {
    let shipName = { shipNameImokey: [] };

    if (applyFilterValue !== "" && applyFilterValue !== undefined) {
      if (applyFilterValue.HistoricVessel == true) {
        shipName = { ...shipName, HistoricVessel: true }
      } else {
        shipName = { ...shipName, HistoricVessel: false }
      }
    }

    let arr = []
    stepsVal.map((value, index) => {
      let isExist = arr.includes(value.vesselKey);
      if (index === 0) {
        let isAvail = { id: value.vesselKey, name: value.currentVesselName }
        shipName.shipNameImokey.push(isAvail)
        arr.push(value.vesselKey);
      } else {
        if (isExist === false) {
          let isAvail = { id: value.vesselKey, name: value.currentVesselName }
          shipName.shipNameImokey.push(isAvail)
          arr.push(value.vesselKey);
        }
      }
    })
    if (editScheduleValues.length) {
      stepsVal.map((value, index) => {
        previewValues[index].schedulerMasterVessel_ID = value.schedulerMasterVessel_ID;
      })

      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/SchedulerupdateData`;
      postRequest(url, previewValues)
        .then((res) => {
          if (res.status == 200) {
            ToastSuccess("Updated Successfully");
            setOpenPreview(false)
            setOpenPrint(true);
            debugger
            getShedularTotalData(shipName);
            //setPreviewColors([]);
            setEditScheduleValues(stepperparameters);

          } else {
            ToastSuccess("Updated Unsucessfull");
          }

        })
        .catch((error) => {

        });
    }
    else if (stepsVal[0].flag === "Scheduled") {
      previewValues[0].schedulerMasterVessel_ID = stepsVal[0].schedulerMasterVessel_ID;
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/SchedulerupdateData`;
      postRequest(url, previewValues)
        .then((res) => {
          if (res.status == 200) {
            ToastSuccess("Updated Successfully");
            setOpenPreview(false)
            setOpenPrint(true);
            debugger
            getShedularTotalData(shipName);
            //setPreviewColors([]);

          } else {
            ToastSuccess("Updated Unsucessfull");
          }

        })
        .catch((error) => {

        });
    }
    else {
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/SchedulerinsertData`;
      postRequest(url, previewValues)
        .then((res) => {
          if (res.status == 200) {
            ToastSuccess("Submited Successfully");
            setOpenPreview(false)
            setOpenPrint(true);
            debugger
            getShedularTotalData(shipName);
            //setPreviewColors([]);

          } else {
            ToastSuccess("Submited Unsucessfull");
          }

        })
        .catch((error) => {

        });
    }
  }

  const handleStepperValidation = () => {
    if (stepperFormvalues.Unit_Service_time !== "" && stepperFormvalues.Oil_Service_time !== "") {
      let arr = [...previewValues];
      arr[activeStep] = stepperFormvalues;
      setpreviewValues(arr);

      let arr1 = [...previewColors];
      arr1[activeStep] = editValueColor;
      setPreviewColors(arr1);

      handleStepperNextstep();
    }
    else {
      ToastError("Fill the required fields")
    }
  }

  const handleStepperNextstep = () => {
    if (previewColors.length > activeStep + 1) {
      setEditValueColor(previewColors[activeStep + 1])
    }
    else {
      setEditValueColor(editColor)
    }

    if (activeStep === steps.length - 1) {
      handleStepperPreview();
      setStepperFormvalues(stepperparameters);
    }
    else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (previewValues.length > activeStep + 1) {
        setStepperFormvalues(previewValues[activeStep + 1])
      }
      else {
        if (editScheduleValues[activeStep + 1]) {
          setStepperFormvalues({
            ...stepperFormvalues,
            Oil_brand: editScheduleValues[activeStep + 1].oil_brand,
            Oil_Grade: editScheduleValues[activeStep + 1].oil_Grade,
            Oil_Quantity_in_system: editScheduleValues[activeStep + 1].oil_Quantity_in_system,
            Fuel_in_user: editScheduleValues[activeStep + 1].fuel_in_user,
            Daily_top_up_in_liters: editScheduleValues[activeStep + 1].daily_top_up_in_liters,
            Unit_Service_time: editScheduleValues[activeStep + 1].unit_Service_time,
            Oil_Service_time: editScheduleValues[activeStep + 1].oil_Service_time,
            sampled_by: editScheduleValues[activeStep + 1].sampled_by,
            Comments: editScheduleValues[activeStep + 1].comments,
            vesselID: editScheduleValues[activeStep + 1].vesselID,
            EquipmentID: editScheduleValues[activeStep + 1].equipmentID,
            Sampledate: editScheduleValues[activeStep + 1].sampledate,
            CustomerName: editScheduleValues[activeStep + 1].customerName,
            VPS_EquipmentID_No: editScheduleValues[activeStep + 1].vpS_EquipmentID_No,
            ManufacturerMake: editScheduleValues[activeStep + 1].manufacturerMake,
            Model: editScheduleValues[activeStep + 1].model,
            PrimaryComponent: editScheduleValues[activeStep + 1].primaryComponent,
            vesselKey: editScheduleValues[activeStep + 1].vesselKey,
            MachineryKey: editScheduleValues[activeStep + 1].machineryKey,
          });
        }
        else {
          setStepperFormvalues({
            ...stepperFormvalues,
            Oil_brand: stepsVal[activeStep + 1].lastKnownLubeBrand,
            Oil_Grade: stepsVal[activeStep + 1].lastKnownLubeGrade,
            Oil_Quantity_in_system: "",
            Fuel_in_user: "",
            Daily_top_up_in_liters: "",
            Unit_Service_time: "",
            Oil_Service_time: "",
            sampled_by: "",
            Comments: "",
            vesselID: stepsVal[activeStep + 1].currentVesselName,
            EquipmentID: stepsVal[activeStep + 1].equimentName,
            Sampledate: stepsVal[activeStep + 1].lastSamplingDate,
            CustomerName: stepsVal[activeStep + 1].customerName,
            VPS_EquipmentID_No: stepsVal[activeStep + 1].vps_equipment_id_no,
            ManufacturerMake: stepsVal[activeStep + 1].make,
            Model: stepsVal[activeStep + 1].model,
            PrimaryComponent: stepsVal[activeStep + 1].primaryComponent,
            vesselKey: stepsVal[activeStep + 1].vesselKey,
            MachineryKey: stepsVal[activeStep + 1].machineryKey,
          });
        }
      }
    }
  };

  const handleStepperPreview = () => {
    setOpenStepper(false);
    setOpenPreview(true);
    setActiveStep(0);
  };
  const handleStepperStepback = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setStepperFormvalues(previewValues[activeStep - 1]);
    setEditValueColor(previewColors[activeStep - 1]);
  };

  const getStepsLabelSelectedrows = () => {
    let isExists;
    let isPresent = [];
    (grouping ?
      selectedRows.forEach((d) => {
        isExists = scheduleValue.find(o => o.equimentName == d.Equipment && o.flag == d.Flag && o.lastSamplingDate == d.LastSampleDate
          && o.lastKnownLubeBrand == d.LoBrand && o.lastKnownLubeGrade == d.LoGrade && o.make == d.Make
          && o.model == d.Model && o.nextSamplingDate == d.NextSampleDate && o.samplingFrequency == d.SamplingFrequency && o.schedulerMasterVessel_ID == d.ScheduleId);
        isPresent.push(isExists);
      })
      :
      isPresent = selectedRows)
    setStepsVal(isPresent);
    setStepperFormvalues({
      ...stepperFormvalues,
      Oil_brand: isPresent[0].lastKnownLubeBrand,
      Oil_Grade: isPresent[0].lastKnownLubeGrade,
      vesselID: isPresent[0].currentVesselName,
      EquipmentID: isPresent[0].equimentName,
      Sampledate: isPresent[0].lastSamplingDate,
      CustomerName: isPresent[0].customerName,
      VPS_EquipmentID_No: isPresent[0].vps_equipment_id_no,
      ManufacturerMake: isPresent[0].make,
      Model: isPresent[0].model,
      PrimaryComponent: isPresent[0].primaryComponent,
      vesselKey: isPresent[0].vesselKey,
      MachineryKey: isPresent[0].machineryKey,
    })

    const labelValue = isPresent.reduce((d, val) => {
      d.push({ label: val.currentVesselName });
      return d;
    }, []);
    setStepperVal(labelValue);

  }

  const getStepsLabel = () => {
    const labelValue = scheduleValue.reduce((d, val) => {
      d.push({ label: val.currentVesselName });
      return d;
    }, []);
    let generateSteps = labelValue.slice(0, 20);
    setStepperVal(generateSteps);
    setStepsVal(scheduleValue);
    setStepperFormvalues({
      ...stepperFormvalues,
      Oil_brand: scheduleValue[0].lastKnownLubeBrand,
      Oil_Grade: scheduleValue[0].lastKnownLubeGrade,
      vesselID: scheduleValue[0].currentVesselName,
      EquipmentID: scheduleValue[0].equimentName,
      Sampledate: scheduleValue[0].lastSamplingDate,
      CustomerName: scheduleValue[0].customerName,
      VPS_EquipmentID_No: scheduleValue[0].vps_equipment_id_no,
      ManufacturerMake: scheduleValue[0].make,
      Model: scheduleValue[0].model,
      PrimaryComponent: scheduleValue[0].primaryComponent,
      vesselKey: scheduleValue[0].vesselKey,
      MachineryKey: scheduleValue[0].machineryKey,
    })
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const getShedularTotalData = (data) => {
    debugger
    setApplyFilterValue(data);
    let filterObj = {};
    let Data = {};
    if (data !== "" && data !== undefined) {
      if (data.HistoricVessel == true) {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
      } else {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
      }
      if (data.customerNameKey && data.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: data.customerNameKey } }
      if (data.shipNameImokey && data.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: data.shipNameImokey } }
      if (data.lubeequipname && data.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: data.lubeequipname } }
      if (data.lubeequipmake && data.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: data.lubeequipmake } }
      if (data.lubeequipmodel && data.lubeequipmodel.length > 0) { filterObj = { ...filterObj, lubeequipmodel: data.lubeequipmodel } }
      if (data.lobrand && data.lobrand.length > 0) { filterObj = { ...filterObj, lobrand: data.lobrand } }
      if (data.lograde && data.lograde.length > 0) { filterObj = { ...filterObj, lograde: data.lograde } }
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    } else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 },{ id: 1, name: 1 }] }
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler`;

    postRequest(url, Data)
      .then((res) => {
        res.data.forEach((d) => {
          if (d.lastSamplingDate) {
            d.lastSamplingDate = moment(d.lastSamplingDate).format('DD/MM/YYYY');
          }
          if (d.nextSamplingDate) {
            d.nextSamplingDate = moment(d.nextSamplingDate).format('DD/MM/YYYY');
          }
        })
        if (res.data.length) {
          let existCurrentVesselName = [];
          let existContractId = [];
          let listOfSchedulerShip = [];
          let filterScheduleVal = [];
          let listofStepperValue = [];
          res.data.map((row) => {
            //if (row.flag !== "Good" && row.flag !== "Scheduled") {
            if (row.flag !== "Scheduled") {
              listofStepperValue.push(row);
            }
          })
          if (grouping) { //Grouping is enabled 
            if (stepsVal.length) { // after Scheduled record only display in mui table
              let isExists;
              let isPresent = [];

              stepsVal.forEach((d) => {
                isExists = res.data.find(o => o.currentVesselName == d.currentVesselName && o.customerName == d.customerName && o.equimentName == d.equimentName
                  && o.lastKnownLubeBrand == d.lastKnownLubeBrand && o.lastKnownLubeGrade == d.lastKnownLubeGrade && o.lastSamplingDate == d.lastSamplingDate
                  && o.machineryKey == d.machineryKey && o.make == d.make && o.model == d.model && o.nextSamplingDate == d.nextSamplingDate && o.primaryComponent == d.primaryComponent
                  && o.samplingFrequency == d.samplingFrequency && o.vps_equipment_id_no == d.vps_equipment_id_no);
                isPresent.push(isExists);
              })

              res.data = isPresent;
              res.data.map((row) => {
                let currentVesselindex = existCurrentVesselName.indexOf(row.currentVesselName);
                let contractIdIndex = existContractId.indexOf(row.axContractId);
                if (currentVesselindex > -1) {
                  let subObj = {
                    ...equipmentList,
                    Equipment: row.equimentName,
                    EquipmentIdNo: row.vps_equipment_id_no,
                    Make: row.make,
                    Model: row.model,
                    LoBrand: row.lastKnownLubeBrand,
                    LoGrade: row.lastKnownLubeGrade,
                    Flag: row.flag,
                    LastSampleDate: row.lastSamplingDate,
                    SamplingFrequency: row.samplingFrequency,
                    NextSampleDate: row.nextSamplingDate,
                    ScheduleId: row.schedulerMasterVessel_ID,
                  }
                  listOfSchedulerShip[currentVesselindex].EquipmentList.push(subObj);

                } else {
                  existCurrentVesselName.push(row.currentVesselName);
                  existContractId.push(row.axContractId);
                  let subObj = {
                    ...equipmentList,
                    Equipment: row.equimentName,
                    EquipmentIdNo: row.vps_equipment_id_no,
                    Make: row.make,
                    Model: row.model,
                    LoBrand: row.lastKnownLubeBrand,
                    LoGrade: row.lastKnownLubeGrade,
                    Flag: row.flag,
                    LastSampleDate: row.lastSamplingDate,
                    SamplingFrequency: row.samplingFrequency,
                    NextSampleDate: row.nextSamplingDate,
                    ScheduleId: row.schedulerMasterVessel_ID,
                  }
                  var ast = row.currentVesselName ? row.currentVesselName : "";
                  var assetWithSpace = "";
                  if (ast) {
                    assetWithSpace = ast.split("(")[0] + " (" + ast.split("(")[1];
                  }
                  let obj = {
                    ...customerList,
                    Asset: assetWithSpace,
                    CustomerContract: row.customerName,
                    contractNumber: row.axContractId,
                    Flag: row.flag,
                    GroupFlag: row.groupFlag,
                    EquipmentList: [subObj]
                  }
                  listOfSchedulerShip.push(obj);
                }
              })
              setStepsVal("")
            }
            else {


              res.data.map((row) => {
                let currentVesselindex = existCurrentVesselName.indexOf(row.currentVesselName);
                let contractIdIndex = existContractId.indexOf(row.axContractId);
                if (currentVesselindex > -1) {
                  let subObj = {
                    ...equipmentList,
                    Equipment: row.equimentName,
                    EquipmentIdNo: row.vps_equipment_id_no,
                    Make: row.make,
                    Model: row.model,
                    LoBrand: row.lastKnownLubeBrand,
                    LoGrade: row.lastKnownLubeGrade,
                    Flag: row.flag,
                    LastSampleDate: row.lastSamplingDate,
                    SamplingFrequency: row.samplingFrequency,
                    NextSampleDate: row.nextSamplingDate,
                    ScheduleId: row.schedulerMasterVessel_ID,
                  }
                  listOfSchedulerShip[currentVesselindex].EquipmentList.push(subObj);

                } else {
                  existCurrentVesselName.push(row.currentVesselName);
                  existContractId.push(row.axContractId);
                  let subObj = {
                    ...equipmentList,
                    Equipment: row.equimentName,
                    EquipmentIdNo: row.vps_equipment_id_no,
                    Make: row.make,
                    Model: row.model,
                    LoBrand: row.lastKnownLubeBrand,
                    LoGrade: row.lastKnownLubeGrade,
                    Flag: row.flag,
                    LastSampleDate: row.lastSamplingDate,
                    SamplingFrequency: row.samplingFrequency,
                    NextSampleDate: row.nextSamplingDate,
                    ScheduleId: row.schedulerMasterVessel_ID,
                  }
                  var ast = row.currentVesselName ? row.currentVesselName : "";
                  var assetWithSpace = "";
                  if (ast) {
                    assetWithSpace = ast.split("(")[0] + " (" + ast.split("(")[1];
                  }
                  let obj = {
                    ...customerList,
                    Asset: assetWithSpace,
                    CustomerContract: row.customerName,
                    contractNumber: row.axContractId,
                    Flag: row.flag,
                    GroupFlag: row.groupFlag,
                    EquipmentList: [subObj]
                  }
                  listOfSchedulerShip.push(obj);
                }
              })
            }
          }
          else {
            if (stepsVal.length) { // for ungrouping after Scheduled record only display in mui table
              let isExists;
              let isPresent = [];

              stepsVal.forEach((d) => {
                isExists = res.data.find(o => o.currentVesselName == d.currentVesselName && o.customerName == d.customerName && o.equimentName == d.equimentName
                  && o.lastKnownLubeBrand == d.lastKnownLubeBrand && o.lastKnownLubeGrade == d.lastKnownLubeGrade && o.lastSamplingDate == d.lastSamplingDate
                  && o.machineryKey == d.machineryKey && o.make == d.make && o.model == d.model && o.nextSamplingDate == d.nextSamplingDate && o.primaryComponent == d.primaryComponent
                  && o.samplingFrequency == d.samplingFrequency && o.vps_equipment_id_no == d.vps_equipment_id_no);
                isPresent.push(isExists);
              })

              res.data = isPresent;
              setStepsVal("");
            }
            listOfSchedulerShip = res.data;


          }

          setSchedulerList(listOfSchedulerShip)
          setScheduleValue(listofStepperValue);
          setEditScheduleCheck(res.data);
          setFilterChipValue(res.data);
          let filter = props.match.params.ship;
          if (filter !== "" && filter !== null && filter !== undefined && (data == "" || data == undefined)) {
            setFlagVal("")
            let Notificationfiltervalue = listOfSchedulerShip.filter((val) =>
              val.Asset == filter
            );
            let isPresent = [];
            filter = filter.split("(");
            let a = filter[0].slice(0, -1) + '(';
            filter = a.concat(filter[1]);
            res.data.forEach((row) => {
              if (row.currentVesselName === filter) {
                isPresent.push(row);
              }
            })
            setEditScheduleCheck(isPresent);
            setFilterChipValue(isPresent);
            if (grouping) {
              setSchedulerList(Notificationfiltervalue);
            } else {
              setSchedulerList(isPresent);
            }
          }

        } else {
          setSchedulerList([]);
        }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };

  useEffect(() => {
    debugger
    if (props.match.params.ship !== '' && props.match.params.ship !== null && props.match.params.ship !== undefined) {
      getShedularTotalData();
    }
    
  }, [props.match.params.ship])

  const columns1 = [
    {
      name: "currentVesselName",
      label: "Ship Name (IMO)",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "customerName",
      label: "Customer Name",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "groupFlag",
      label: "Group Flag",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === "Good") {
            return <><span style={{ color: "#006600" }}>Good</span> </>
          } else if (value === "OverDue") {
            return <><span style={{ color: "red" }}>OverDue</span></>
          } else if (value === "Due Soon") {
            return <><span style={{ color: "orange" }}>Due Soon</span></>
          } else if (value === "Scheduled") {
            return <><span style={{ color: "orange" }}>Scheduled</span></>
          }
        }
      }
    },
    {
      name: "equimentName",
      label: "Equipment",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "vps_equipment_id_no",
      label: "VPS Equipment ID No",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "make",
      label: "Make",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "model",
      label: "Model",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "lastKnownLubeBrand",
      label: "LO Brand",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "lastKnownLubeGrade",
      label: "LO Grade",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "lastSamplingDate",
      label: "Last Sample Date",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "samplingFrequency",
      label: "Sampling Frequecy",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === 0) {
            return ("Ad hoc")
          }
          else {
            return (value)
          }
        }
      }
    },
    {
      name: "nextSamplingDate",
      label: "Next Sample Date",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "flag",
      label: "Flag",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (tableMeta.rowData[10] !== 0) {
            if (value === "Good") {
              return <><span style={{ color: "#006600" }}>Good</span> </>
            } else if (value === "OverDue") {
              return <><span style={{ color: "red" }}>OverDue</span></>
            } else if (value === "Due Soon") {
              return <><span style={{ color: "orange" }}>Due Soon</span></>
            } else if (value === "Scheduled") {
              return <><span style={{ color: "orange" }} onClick={() => { checkboxSelectedValue.length = 0; checkboxSelectedValue.push(schedulerList[tableMeta.currentTableData[tableMeta.rowIndex].index]); handleScheduleOnClick() }}>Scheduled</span></>
            }
          } else {
            return (<></>)
          }
        }

      }
    },
    {
      name: "flag",
      label: "Label",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (value, tableMeta) => {
          if (value === "Scheduled") {
            return (
              <Button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { checkboxSelectedValue.length = 0; checkboxSelectedValue.push(schedulerList[tableMeta.currentTableData[tableMeta.rowIndex].index]); handlePrintlabelOnClick() }}  ><img src="/assets/images/F-icon.png" style={{ width: "20px" }} /> </Button>
            )
          }
        }
      }
    },
    {
      name: "Checkbox",
      label: <>Filters<Button>
        <Checkbox defaultChecked disabled />
        <ArrowDropDownIcon onClick={handleFilterListOpen} />
        <Menu
          anchorEl={chechboxVal}
          open={dropDownOpen}
          onClose={handleFilterListClose}
        >
          <MenuItem onClick={handleFilterListApply}>All</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Good</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Due Soon</MenuItem>
          <MenuItem onClick={handleFilterListApply}>OverDue</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Scheduled</MenuItem>
        </Menu>
      </Button>
      </>,
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          return (<Checkbox onChange={(newvalue) => {
            let item = schedulerList[tableMeta.currentTableData[tableMeta.rowIndex].index]
            if (newvalue.target.checked === true) {
              let index = checkboxSelectedValue.indexOf(item);
              if (index === -1) {
                checkboxSelectedValue.push(item);
              }
            }
            else {
              let index = checkboxSelectedValue.indexOf(item);
              if (index > -1) {
                checkboxSelectedValue.splice(index, 1);
              }
            }
          }} />)
        }
      }
    },

  ];

  const columns = [
    {
      name: "Asset",
      label: "Ship Name (IMO)",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "CustomerContract",
      label: "Customer Name",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "GroupFlag",
      label: "Flag",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === "Good") {
            return <><span style={{ color: "#006600" }}>Good</span> </>
          } else if (value === "OverDue") {
            return <><span style={{ color: "red" }}>OverDue</span></>
          } else if (value === "Due Soon") {
            return <><span style={{ color: "orange" }}>Due Soon</span></>
          } else if (value === "Scheduled") {
            return <><span style={{ color: "orange" }}>Scheduled</span></>
          }
        }
      }
    },
    {
      name: "Checkbox",
      label: <>Filters<Button>
        <Checkbox defaultChecked disabled />
        <ArrowDropDownIcon onClick={handleFilterListOpen} />
        <Menu
          anchorEl={chechboxVal}
          open={dropDownOpen}
          onClose={handleFilterListClose}
        >
          <MenuItem onClick={handleFilterListApply}>All</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Good</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Due Soon</MenuItem>
          <MenuItem onClick={handleFilterListApply}>OverDue</MenuItem>
          <MenuItem onClick={handleFilterListApply}>Scheduled</MenuItem>
        </Menu>
      </Button>
      </>,
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          return ""
        }
      }
    },
  ];
  const clear = () => (
    <>
      <Tooltip disableFocusListener title="Notification Clear" >
        <IconButton onClick={NotificationClear} className={classes.btnStyle3} disabled={props.match.params.ship !== "" && props.match.params.ship !== null && props.match.params.ship !== undefined ? false : true} >
          <ClearIcon />
        </IconButton>
      </Tooltip>
      {/* <Tooltip  title={toolTipValue()} >
      <IconButton onClick={SchedulerGrouping} className={classes.btnStyle3} >
        {grouping?<CheckBoxIcon />:<CheckBoxOutlineBlankIcon />}
      </IconButton>
    </Tooltip> */}
    </>
  );
  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete:true,
      </>

    },
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    filter: true,
    filterType: 'multiselect',
    responsive: 'standard',
    customToolbar: clear,
    expandableRows: (grouping ? true : false),
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    download: true,
    downloadOptions: {
      filename: 'tableDownload.csv',
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true
      }
    },
    customTableBodyFooterRender: () => {
      return (
        <TableRow >
          <TableCell colSpan={9}>
            <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
              <Button variant="outlined" className={classes.btnStyle2} onClick={handleRaiseRequest('paper')}>
                Schedule Next Sampling
              </Button>
              <Button variant="outlined" className={classes.btnStyle1} onClick={handleEditSchedule} >
                Edit Scheduled Sampling
              </Button>
            </Box>
          </TableCell>
        </TableRow>
      )
    },
    onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
      setFlagVal("");
      let isPresent = [];
      let data = [];
      if (grouping) {
        displayData.forEach((d, index) => {
          data.push(d.data[0]);
        })
      }
      else {
        displayData.forEach((d, index) => {
          let isExist = data.includes(d.data[0]);
          if (index === 0) {
            data.push(d.data[0]);
          }
          else {
            if (isExist === false) {
              data.push(d.data[0]);
            }
          }
        })
      }

      data.forEach((d, index) => {
        if (grouping) {
          d = d.split("(");
          let a = d[0].slice(0, -1) + '(';
          d = a.concat(d[1]);
        }
        editScheduleCheck.forEach((row) => {
          if (row.currentVesselName === d) {
            isPresent.push(row)
          }
        })
      })
      setFilterChipValue(isPresent);
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      let isExistSchedularShip = [];
      rowsSelected.forEach((d) => {
        isExistSchedularShip.push(schedulerList[d]);
      })
      setSelectedSchedulerListShip(isExistSchedularShip);
    },

    onDownload: (grouping ? (buildHead, buildBody, columns, gridData) => {

      var myData = [];
      var newKeys = Object.keys(schedulerList[0].EquipmentList[0]);
      var idx = 0;
      //;
      var columnsExport = [];
      var dataExport = [];
      columnsExport.push(" ");
      columns.forEach((cl) => {
        if (cl.label !== "Flag" && cl.name !== "Checkbox")
          columnsExport.push(cl.label);
      });
      newKeys.forEach((k) => {
        if (k !== "ScheduleId") {
          columnsExport.push(k);
        }
      });
      columnsExport.push("\n");
      let i = 0;
      selectedSchedulerListShip.length > 0 ?
        (
          selectedSchedulerListShip.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.Asset && dfdt[1] == item.CustomerContract)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {
              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;
              let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
              itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
              delete itemData.Flag;
              delete itemData.GroupFlag;
              delete itemData.EquipmentList;
              delete itemData.contractNumber;
              itemEquipments.forEach((ie, idx) => {
                delete ie.ScheduleId
                let data = [];
                data.push(...Object.values({ ...itemData, ...ie }));
                data.push("\n");
                dataItem.push(data);
              });
              myData.push(...dataItem);
            }
          })
        ) : (
          schedulerList.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.Asset && dfdt[1] == item.CustomerContract)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {
              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;
              let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
              itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
              delete itemData.Flag;
              delete itemData.GroupFlag;
              delete itemData.EquipmentList;
              delete itemData.contractNumber;
              itemEquipments.forEach((ie, idx) => {
                delete ie.ScheduleId
                let data = [];
                data.push(...Object.values({ ...itemData, ...ie }));
                data.push("\n");
                dataItem.push(data);
              });
              myData.push(...dataItem);
            }
          })
        )

      buildHead = () => {
        return columnsExport;
      }
      buildBody = () => {
        return myData;
      }
      return buildHead() + buildBody();
    } :
      (buildHead, buildBody, columns, gridData) => {
        var myData = [];
        var idx = 0;
        var columnsExport = [];
        var dataExport = [];
        columnsExport.push(" ");
        columns.forEach((cl) => {
          if (cl.label !== "Group Flag" && cl.name !== "Checkbox" && cl.label !== "Label")
            columnsExport.push(cl.label);
        });
        columnsExport.push("\n");
        let i = 0;
        selectedSchedulerListShip.length > 0 ?
          (
            selectedSchedulerListShip.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.currentVesselName && dfdt[1] == item.customerName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {
                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                let objsample = {
                  shipname: itemData.currentVesselName,
                  customername: itemData.customerName,
                  equipment: itemData.equimentName,
                  vpsequipmentidno: itemData.vps_equipment_id_no,
                  make: itemData.make,
                  model: itemData.model,
                  lobrand: itemData.lastKnownLubeBrand,
                  lograde: itemData.lastKnownLubeGrade,
                  lastsampledate: itemData.lastSamplingDate,
                  samplefrequency: itemData.samplingFrequency,
                  nextsampledate: itemData.nextSamplingDate,
                  flag: itemData.flag
                }
                let data = [];
                data.push(...Object.values({ ...objsample }));
                data.push("\n");
                dataItem.push(data);

                myData.push(...dataItem);
              }
            })
          ) : (
            schedulerList.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.currentVesselName && dfdt[1] == item.customerName)
                  return true;
                else
                  return false;

              });

              if (visibleRows.length > 0) {
                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                let objsample = {
                  shipname: itemData.currentVesselName,
                  customername: itemData.customerName,
                  equipment: itemData.equimentName,
                  vpsequipmentidno: itemData.vps_equipment_id_no,
                  make: itemData.make,
                  model: itemData.model,
                  lobrand: itemData.lastKnownLubeBrand,
                  lograde: itemData.lastKnownLubeGrade,
                  lastsampledate: itemData.lastSamplingDate,
                  samplefrequency: itemData.samplingFrequency,
                  nextsampledate: itemData.nextSamplingDate,
                  flag: itemData.flag
                }
                let data = [];
                data.push(...Object.values({ ...objsample }));
                data.push("\n");
                dataItem.push(data);
                myData.push(...dataItem);
              }
            })
          )

        buildHead = () => {
          return columnsExport;
        }
        buildBody = () => {
          return myData;
        }
        return buildHead() + buildBody();
      }
    ),
    isRowExpandable: (dataIndex, expandedRows) => {

      // if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length < 0 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;

    },
    rowsExpanded: [],
    renderExpandableRow: (rowData, rowMeta) => {
      //
      let expandeditem = schedulerList.filter((value) => {
        return value.Asset === rowData[0]
      })

      const colSpan = rowData.length + 1;
      return (
        <TableRow>

          <TableCell colSpan={colSpan}>
            <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
              <Table className={classes.tableLayout}>

                <TableRow style={{ backgroundColor: grey[400] }}>
                  <StyledTableCell >
                    Equipment
                  </StyledTableCell>
                  <StyledTableCell>
                    VPS Equipment ID No
                  </StyledTableCell>
                  <StyledTableCell >
                    Make
                  </StyledTableCell>
                  <StyledTableCell >
                    Model
                  </StyledTableCell>
                  <StyledTableCell >
                    LO Brand
                  </StyledTableCell>
                  <StyledTableCell >
                    LO Grade
                  </StyledTableCell>
                  <StyledTableCell >
                    Last Sample Date
                  </StyledTableCell>
                  <StyledTableCell >
                    Sampling Frequecy
                  </StyledTableCell>
                  <StyledTableCell >
                    Next Sample Date
                  </StyledTableCell>
                  <StyledTableCell >
                    Flag
                  </StyledTableCell>
                  <StyledTableCell >
                    Label
                  </StyledTableCell>
                  <StyledTableCell >

                  </StyledTableCell>
                </TableRow>

                <TableBody>

                  {expandeditem[0].EquipmentList?.map((item, index) => (
                    <TableRow>
                      <TableCell >{item.Equipment}</TableCell>
                      <TableCell >{item.EquipmentIdNo}</TableCell>
                      <TableCell >{item.Make}</TableCell>
                      <TableCell >{item.Model}</TableCell>
                      <TableCell >{item.LoBrand}</TableCell>
                      <TableCell >{item.LoGrade}</TableCell>
                      <TableCell >{item.LastSampleDate}</TableCell>
                      <TableCell >{item.SamplingFrequency == 0 ? "Ad hoc" : item.SamplingFrequency}</TableCell>
                      <TableCell >{item.NextSampleDate}</TableCell>
                      <TableCell style={getFlagColor(item.Flag)}>{item.SamplingFrequency == 0 ? "" : item.Flag === "Scheduled" ? <span onClick={() => { checkboxSelectedValue.length = 0; checkboxSelectedValue.push(item); handleScheduleOnClick() }} style={{ cursor: "pointer" }}>{item.Flag}</span> : item.Flag}</TableCell>
                      <TableCell>{item.Flag === "Scheduled" ? <Button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }} onClick={() => { checkboxSelectedValue.length = 0; checkboxSelectedValue.push(item); handlePrintlabelOnClick() }} ><img src="/assets/images/F-icon.png" style={{ width: "20px" }} /> </Button> : ""}</TableCell>
                      <TableCell><Checkbox onChange={(newvalue) => {

                        if (newvalue.target.checked === true) {
                          let index = checkboxSelectedValue.indexOf(item);
                          if (index === -1) {
                            checkboxSelectedValue.push(item);
                          }
                        }
                        else {
                          let index = checkboxSelectedValue.indexOf(item);
                          if (index > -1) {
                            checkboxSelectedValue.splice(index, 1);
                          }
                        }
                      }} /></TableCell>
                    </TableRow>

                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </TableCell>
        </TableRow >

      );
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
      console.log(curExpanded, allExpanded, rowsExpanded),
  };
  const onSubmitFilter = (obj) => {
    debugger
    setFlagVal("");
    // if (obj.HistoricVessel == false) { delete obj.HistoricVessel }
    // if (obj.customerNameKey && obj.customerNameKey.length == 0) { delete obj.customerNameKey }
    // if (obj.shipNameImokey && obj.shipNameImokey.length == 0) { delete obj.shipNameImokey }
    // if (obj.lubeequipname && obj.lubeequipname.length == 0) { delete obj.lubeequipname }
    // if (obj.lubeequipmake && obj.lubeequipmake.length == 0) { delete obj.lubeequipmake }
    // if (obj.lubeequipmodel && obj.lubeequipmodel.length == 0) { delete obj.lubeequipmodel }
    // if (obj.lobrand && obj.lobrand.length == 0) { delete obj.lobrand }
    // if (obj.lograde && obj.lograde.length == 0) { delete obj.lograde }
    // if (Object.entries(obj).length) {
    //   getShedularTotalData(obj)
    // } else {
    //   getShedularTotalData();
    // }
    getShedularTotalData(obj)
  }
  const handleDateData = (event, type) => {
    let dateFormat = "";
    if (event) {
      dateFormat = event.format('YYYY-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
  }

  return (

    <>
      <div>
        <Dialog
          maxWidth="xl"
          fullWidth
          maxWidth="sm"
          open={openpdf}
        >
          <DialogContent>
            {pdfURL ? (
              <iframe
                src={`${pdfURL}#page=1&toolbar=0`}
                width="100%"
                style={{ "min-height": '100%' }, { "height": `${window.screen.height - 90}px` }}
              ></iframe>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <a href={`${pdfURL}#page=1&toolbar=0`} download={pdfName} style={{ textDecoration: "none" }}>

              <Button>Download</Button></a>
            <Button onClick={() => { handleClose(true) }}> <CancelIcon /></Button>
          </DialogActions>

        </Dialog>
      </div>
      <div>
        <Dialog
          open={open}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Steps to create a sample label</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
            >
              <ol className="subtitle2">
                <li><p className="subtitle3">Step 1: Confirm and fill relevant data in the form for every sample.</p></li>
                <p>Example: You need to fill in 20 Equipments if you have selected 20 samples</p>
                <li><p className="subtitle3">Step 2: Preview all sample details.</p></li>
                <li><p className="subtitle3">Step 3: Submit the form.</p></li>
                <li><p className="subtitle3">Step 4: Print the label and add to the sample box.</p></li>
              </ol>
            </DialogContentText>
            <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
              <Button variant="outlined" className={classes.btnStyle1} onClick={handleCloseRaiserequest} >
                Back
              </Button>
              <Button variant="outlined" className={classes.btnStyle2} onClick={handleStepperOpen}>
                Next
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openRemoveLabel}
        >
          <DialogTitle className={classes.alertTabRoot}>
            {"Are you sure you want to remove this label?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              <h6>* Scheduler label will be removed by this action.</h6>
            </DialogContentText>
          </DialogContent>
          <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
            <Button variant="outlined" className={classes.btnStyle1} onClick={handleStepperStepsDeleteClose}>Disagree</Button>
            <Button variant="outlined" className={classes.btnStyle2} onClick={handleRemoveStepperLabel}>Agree</Button>
          </Box>
        </Dialog>

        {stepsVal ? <Dialog
          open={openStepper}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogContent dividers={scroll === 'paper'}>
            <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepperIcon}>
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    optional={
                      index === steps.length - 1 ? (
                        <Typography variant="caption">Last step</Typography>
                      ) : null
                    }
                  >
                    {step.label} - {stepsVal[index].equimentName}
                    {index === activeStep && steps.length > 1 ? <Button onClick={handleStepperStepsDelete}><DeleteIcon sx={{ color: "#000000" }} /></Button> : ""}
                    <Box component="div" className="close_blk">
                      <Button onClick={handleStepperEscape}><HighlightOffIcon style={{ color: "#ff4717" }} /></Button>
                    </Box>
                  </StepLabel>
                  <StepContent>
                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={5} >
                          {/* <Grid>
                          <Box component="h6" mb={1} textAlign="left" fontWeight="500">
                            {stepsVal[index].equimentName}

                          </Box>
                        </Grid> */}
                          <Grid className={classes.Grid}>
                            <Box component="div" className="bunkarinput">
                              <Grid container spacing={3}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Sampled Date</label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0">
                                  {stepsVal[index].lastSamplingDate}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="bunkarinput">
                              <Grid container spacing={3} pt={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Customer Name</label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0">
                                  {stepsVal[index].customerName}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="bunkarinput">
                              <Grid container spacing={3} pt={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> VPS Equipment ID No </label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0">
                                  {stepsVal[index].vps_equipment_id_no}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="bunkarinput">
                              <Grid container spacing={3}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Manufacturer Make </label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0">
                                  {stepsVal[index].make}
                                </Grid>
                              </Grid>
                            </Box><Box component="div" className="bunkarinput">
                              <Grid container spacing={3}  >
                                <Grid item xs={6} className="padbtm0" >
                                  <label for="Density"> Model </label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0">
                                  {stepsVal[index].model}
                                </Grid>
                              </Grid>
                            </Box><Box component="div" className="bunkarinput">
                              <Grid container spacing={3}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Primary Component </label>
                                </Grid>
                                <Grid item xs={6} className="padbtm0" >
                                  {stepsVal[index].primaryComponent}
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                        <Grid item xs={7}>
                          <Box component="div" className="Da-container1">

                            <Typography><span className="redstar">Kindly Confirm the following values</span></Typography>

                            <Grid container spacing={3}>
                              <Grid item xs={6} >
                                <TextField id="standard-size-small" label="Oil Brand" variant="standard" value={stepperFormvalues.Oil_brand} className={classes.txtInput} onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Oil_brand: event.target.value }); setEditValueColor({ ...editValueColor, oilBrand: true }) }} />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField id="standard-basic" label="Oil Grade" variant="standard" value={stepperFormvalues.Oil_Grade} className={classes.txtInput} onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Oil_Grade: event.target.value }); setEditValueColor({ ...editValueColor, oilGrade: true }) }} />
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <TextField id="standard-basic" label="Oil Quantity in System" variant="standard" value={stepperFormvalues.Oil_Quantity_in_system} className={classes.txtInput} type="number" onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Oil_Quantity_in_system: event.target.value }); setEditValueColor({ ...editValueColor, oilQuantityInSystem: true }) }} />
                                <span className="steppertext"> Litres</span>
                              </Grid>
                              <Grid item xs={6}>
                                <TextField id="standard-basic" label="Daily Top up in liters" variant="standard" value={stepperFormvalues.Daily_top_up_in_liters} className={classes.txtInput} type="number" onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Daily_top_up_in_liters: event.target.value }); setEditValueColor({ ...editValueColor, dailyTopUpInLiters: true }) }} />
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <TextField id="standard-basic" label="Fuel in Use" variant="standard" value={stepperFormvalues.Fuel_in_user} className={classes.txtInput} onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Fuel_in_user: event.target.value }); setEditValueColor({ ...editValueColor, fuelInUse: true }) }} />
                              </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <TextField id="standard-basic" label="Unit Service Time" variant="standard" value={stepperFormvalues.Unit_Service_time} required className={classes.txtInput} type="number" onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Unit_Service_time: event.target.value }); setEditValueColor({ ...editValueColor, unitServiceTime: true }) }} />
                                <span className="steppertext"> Hours</span>
                              </Grid>
                              <Grid item xs={6}>
                                <TextField id="standard-basic" label="Oil Service Time" variant="standard" value={stepperFormvalues.Oil_Service_time} required className={classes.txtInput} type="number" onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Oil_Service_time: event.target.value }); setEditValueColor({ ...editValueColor, oilServiceTime: true }) }} />
                                <span className="steppertext"> Hours</span>
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <TextField id="standard-basic" label="Sampled By" variant="standard" value={stepperFormvalues.sampled_by} className={classes.txtInput} onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, sampled_by: event.target.value }); setEditValueColor({ ...editValueColor, sampledBy: true }) }} />
                              </Grid>

                            </Grid>

                          </Box>
                        </Grid>
                      </Grid>

                      <Box component="h6" mb={1} textAlign="left" className="blcopy" fontWeight="500" >
                        Comments
                      </Box>
                      <Box component="div" mb={0} className="Da-container2">
                        <TextField id="standard-basic" label="Start Typing to add comments..." variant="standard" className={classes.txtInput1} value={stepperFormvalues.Comments} onChange={(event) => { setStepperFormvalues({ ...stepperFormvalues, Comments: event.target.value }); setEditValueColor({ ...editValueColor, comments: true }) }} />
                        <Box component="h7" m={0} textAlign="left" className="blcopy" fontWeight="500" paddingTop="15px">
                          Scheduling History:
                        </Box>
                      </Box>
                    </Box>
                    <Typography>{step.description}</Typography>
                    <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
                      <div>
                        <Button
                          disabled={index === 0}
                          className={classes.btnStyle1}
                          onClick={handleStepperStepback}
                        //sx={{ mt: 1, mr: 1 }}
                        >
                          Back
                        </Button>
                        {index === steps.length - 1 ?
                          <Button variant="contained" className={classes.btnStyle2} onClick={handleStepperValidation}>
                            Preview
                          </Button>
                          :
                          <Button variant="contained" className={classes.btnStyle2} onClick={handleStepperValidation}>
                            Next
                          </Button>}
                      </div>
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </DialogContent>
        </Dialog> : ""}

        <Dialog
          open={openPreview}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
            >
              {previewValues.map((val, index) => (
                <>
                  <Box component="div" style={{ paddingLeft: "30px", borderBottom: "1.5px dotted #1A1A31" }}>
                    <Grid item xs={12} className="energyb1">
                      <Box component="h3" m={0} textAlign="left" className="blcopy" fontWeight="500">
                        {index === 0
                          ?
                          previewValues[index].vesselID
                          :
                          previewValues[index].vesselID !== previewValues[index - 1].vesselID
                            ?
                            previewValues[index].vesselID
                            : ""}
                      </Box>
                    </Grid>

                    <Box component="div" className="bunkarinput">

                      <Grid item xs={12} md={6} component="h5" style={{ color: 'amber', fontSize: '22px' }}> {previewValues[index].EquipmentID} </Grid>

                    </Box>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>

                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2} >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Sampled Date</label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].Sampledate}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Customer Name</label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].CustomerName}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> VPS Equipment ID No </label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].VPS_EquipmentID_No}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Manufacturer Make </label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].ManufacturerMake}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Model </label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].Model}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Primary Component </label>
                              </Grid>
                              <Grid item xs={6} className="padbtm0">
                                {previewValues[index].PrimaryComponent}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Sample By </label>
                              </Grid>
                              <Grid item xs={6} style={{ color: previewColors[index].sampledBy ? "#ff4717" : "" }} className="padbtm0">
                                {previewValues[index].sampled_by}
                              </Grid>
                            </Grid>
                          </Box>
                          <Box component="div" className="stepperinput">
                            <Grid container spacing={2}  >
                              <Grid item xs={6} className="padbtm0">
                                <label for="Density"> Comments </label>
                              </Grid>
                              <Grid item xs={6} style={{ color: previewColors[index].comments ? "#ff4717" : "" }} className="padbtm0">
                                {previewValues[index].Comments}
                              </Grid>
                            </Grid>
                          </Box>

                        </Grid>

                        <Grid item xs={6}>
                          <Grid className={classes.Grid}>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0" >
                                  <label for="Density">Oil Brand</label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].oilBrand ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Oil_brand}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density">Oil Grade</label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].oilGrade ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Oil_Grade}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Oil Quantity in System </label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].oilQuantityInSystem ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Oil_Quantity_in_system}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density">Fuel in Use </label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].fuelInUse ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Fuel_in_user}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Daily Top up in Liters </label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].dailyTopUpInLiters ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Daily_top_up_in_liters}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Unit Service Time <span className="redstar">*</span></label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].unitServiceTime ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Unit_Service_time}
                                </Grid>
                              </Grid>
                            </Box>
                            <Box component="div" className="stepperinput">
                              <Grid container spacing={2}  >
                                <Grid item xs={6} className="padbtm0">
                                  <label for="Density"> Oil Service Time <span className="redstar">*</span></label>
                                </Grid>
                                <Grid item xs={6} style={{ color: previewColors[index].oilServiceTime ? "#ff4717" : "" }} className="padbtm0">
                                  {previewValues[index].Oil_Service_time}
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                  {index === previewValues.length - 1 ?
                    <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
                      <Button variant="outlined" className={classes.btnStyle1} onClick={handleEditStepperForm} >
                        Edit
                      </Button>
                      <Button variant="outlined" className={classes.btnStyle2} onClick={handleSubmitStepperForm}>
                        Submit
                      </Button>
                    </Box> : ""}
                </>
              ))}
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openPrint}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >

          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
            >
              <Box pb={3} pt={5} sx={{ display: 'flex', justifyContent: 'center' }}>
                <CheckCircleIcon color="success" sx={{ fontSize: 80, }} />
              </Box>
              <Box pb={5} component="h3" mb={1} textAlign="left" className="blcopy" fontWeight="500" >
                Request Submitted successfully!
              </Box>

              ,          </DialogContentText>
            <Box mb={5} component="div" display="flex" py={1} pl={1} justifyContent="center"   >
              <Button variant="outlined" className={classes.btnStyle2} onClick={handlePrintLabel}>
                Print Label
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Box component="main" className={classes.content + " rightbar"}>
          <Box pb={3} pt={0} display="dlock">
            <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />} />
            <div>
            <Box component="div" className="pos_relative">
              <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Scheduler Ship</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Filter Panel</p><br />
                    <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section1.jpg"></img><br /><br />
                    <p>
                      <li>Click and type on the fields to see the options</li><br />
                      <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                      <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear1} alt="" width="300px" height="300px" /></li><br />
                      <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                      <li>Click the <img src={applyfilter} alt="" width="100px" height="100px" /> button to implement the choosen filter</li><br />
                      <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                      <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                    </p><br />
                    <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section2.jpg"></img><br /><br />
                    <p>
                  <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                  <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                  <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                  <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                  <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                  <li>Expand the particular row and Click PDF icon <img src={pdficon} alt="" width="40px" height="40px" /> to open the file in PDF dialog box, on the dialog box right side bottom <img src={downloadpdf} alt="" width="100px" height="100px" />button to download file </li>
                  <div className={classes.text}> as pdf document</div>
                </p>
                <br />
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section3.jpg"></img><br /><br />
                <p>
                  <li>Select <CheckBoxIcon color="primary" /> to download particular row and click <img src={downloadicon} alt="" width="40px" height="40px" /> on the top of the grid</li>
                </p>
                <br/>
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section4.jpg"></img><br /><br />
                <p>
                <li>Click <ArrowForwardIosIcon sx={{ transform: "rotateZ(270deg)" }} color="disabled" /> to see the particular Ship details</li><br />
                  <li>Click the check box of particular equipment and select schedule Next sampling </li>
                </p>
                <br/>
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section5.jpg"></img><br /><br />
                <p>
                   <li>Read the instruction and Click Next button to proceed further</li>   
                </p>
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section6.jpg"></img><br /><br />
                <p>
                  <li>Please fill the mandatory fields for all the selected equipment and Click Next button to another equipment</li><br/>
                  <li>Click the <DeleteIcon color="action" /> to remove a specific item for the stepper component</li><br/>
                  <li>Click <img src={Close} alt="" width="20px" height="20px" /> button to close all the selected equipments</li>
                </p>
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section7.jpg"></img><br /><br />
                <p>
                  <li>Click <img src={Preview} alt="" width="60px" height="60px" /> button to go Preview screen</li><br/>
                </p>   
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section8.jpg"></img><br /><br />
                <p>
                  <li>Click Submit button to save the all selected equipment</li><br/>
                  <li>Click Edit button to go back to previous screen</li><br/> 
                </p>
                <img className="maxwidth100" src="/assets/images/Schedular_page_Ship_help_section9.jpg"></img><br /><br />
                <p>
                  <li>Click the print label button to show the scheduled Pdf</li>
                </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </div>
          </Box>
          <Box className="decarbox1" component="div" style={{ padding: "20px" }}  >
            <FilterComponents screen={"scheduler"} filtervalue={["CustomerName", "ShipName_imo", "EquipName", "EquipMake", "EquipModel", "LoBrand", "LoGrade"]} applyFilter={onSubmitFilter} reset={onClear} />
          </Box>
          {/* <Box pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Box p={2} height={1} className={classes.boxLayout}>
                <Box component="h2" m={0} className="blcopy" fontWeight="500" pb={0}>
                  Filters:
                </Box>
                <Box display="block">
                  <Box pb={1}>

                    <Grid container spacing={3}>
                      <Grid item >
                        <Box component="span" className="date-input" mr={3} fontSize="18px" >
                          Contract date
                        </Box>
                      </Grid>
                      <Grid item >
                        <Box component="span" className="date-input" mr={2}>
                          <KeyboardDatePicker
                            margin="normal"
                            className="mar0"
                            id="date-picker-dialog"
                            // label="Date picker dialog"
                            format="DD/MM/yyyy"
                            invalidDateMessage=""
                            value={formObj.contractStartDate || ""}
                            onChange={(event) => { handleDateData(event, "contractStartDate") }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item >
                        <Box component="span" className="date-input" mr={2} >
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            // label="Date picker dialog"
                            format="DD/MM/yyyy"
                            className="mar0"
                            invalidDateMessage=""
                            value={formObj.contractEndDate || ""}
                            onChange={(event) => { handleDateData(event, "contractEndDate") }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>

                  </Box>
                  <Box component="div" >
                    <Grid container spacing={3} className="reports-filter-row mlr2" alignItems="left" >
                      <Grid spacing={3}  >
                        <Button type="button" onClick={onSubmitFilter} className={classes.btnStyle2}>
                          Apply Filter
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                 

                </Box>

              </Box>
            </Grid>
           
          </Grid>
        </Box> */}
          <Box display="block" pb={5} mb={3} my={3} component="div" className="reportstablehead">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={"Scheduler List-Ship"}
                data={schedulerList}
                columns={grouping ? columns : columns1}
                className={classes.tableBody}
                options={options}
              />

            </ThemeProvider>
          </Box>
        </Box>
      </div>
    </>
  );
}
const getFlagColor = (flag) => {
  var flagcls;
  switch (flag) {
    case "Good":
      flagcls = {
        color: "#006600"
      };
      break;
    case "OverDue":
      flagcls = {
        color: "red"
      };
      break;
    case "Due Soon":
      flagcls = {
        color: "orange"
      };
      break;
    case "Scheduled":
      flagcls = {
        color: "orange",
        textDecoration: "underline",
      };
    default:

  }
  return flagcls;

};
function RowData(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const tableClasses = useRowStyles();
  const classes = useStyles();
  return (
    <React.Fragment>
      <TableRow
        className={clsx(
          tableClasses.root,
          open ? classes.active : classes.inactive
        )}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Asset}
        </TableCell>
        <TableCell>
          {row.CustomerContract}
        </TableCell>
        <TableCell>
          {row.contractNumber}
        </TableCell>
        <TableCell style={getFlagColor(row.GroupFlag)}>
          {row.GroupFlag}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <ShedularDetails row={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

    </React.Fragment>
  );
}

export default withRouter(Scheduler)